import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=ba0b42ec&scoped=true"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=ba0b42ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0b42ec",
  null
  
)

export default component.exports